import { responsiveListTheme } from 'theme/layout/responsiveList';
export const sheet = {
  ItemList: responsiveListTheme,
  list: {
    width: '100%',
    marginBottom: 20,
  },
};
